'use client';
import * as React from 'react';
import Link from 'next/link';

import useRoutePath from '@/hooks/useRoutePath';
import {
  PopularMenuCategory,
  RestaurantMenu,
} from '@/lib/types/customer/restaurant/StoreProfile';
import { MenuCard } from '../shared/MenuCard';
import { useTranslations } from 'next-intl';
import { STOREFRONT } from '@/lib/utils/translation';

interface StoreMenusProps {
  category: PopularMenuCategory;
}

const StoreMenus = ({ category }: StoreMenusProps) => {
  const { pathname } = useRoutePath();
  const t = useTranslations();

  return (
    <section className="pb-10">
      <div className="">
        <div className="mb-6 mt-6">
          <h3 className="text-h3 font-[900] leading-[140%] text-title">
            {category?.name}
          </h3>
        </div>
        <div className="menu-list grid grid-cols-12 gap-x-8 gap-y-4">
          {category?.restaurant_menus.map((item: RestaurantMenu) => {
            return (
              <React.Fragment key={item.id}>
                <MenuCard item={item} />
              </React.Fragment>
            );
          })}
        </div>
        <div className="mt-12">
          <Link
            href={`${pathname}/menus`}
            className="w-auto rounded-full bg-primary px-6 py-4 text-white hover:drop-shadow-xl"
          >
            {t(STOREFRONT.STORE_PROFILE + '.view_all_items')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default StoreMenus;
